import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import deleteStyles from './DeleteConfirm.module.css';
import cls from '../../../TemporaryConmonents/Files/UI/Modals/ModalFiles.module.css';
import { ModalBody } from '../../../TemporaryConmonents/Gant/components/UI/Modal/ModalBody/ModalBody';
import { ModalFooter } from '../../../TemporaryConmonents/Gant/components/UI/Modal/ModalFooter/ModalFooter';

interface IDeleteConfirmProps {
    onHideModal: () => void;
    onDeleteFile: (fileId: string) => void;
    fileId: string | undefined;
}

export const DeleteConfirm = ({ onHideModal, onDeleteFile, fileId }: IDeleteConfirmProps) => {
    const { t } = useTranslation();
    useEffect(() => {
        const handleEscapeDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onHideModal();
            }
            if (event.key === 'Enter' && fileId) {
                onDeleteFile(fileId);
            }
        };

        document.addEventListener('keydown', handleEscapeDown);
        return () => {
            document.removeEventListener('keydown', handleEscapeDown);
        };
    }, [onHideModal, onDeleteFile, fileId]);

    return (
        <div className={deleteStyles.wrapper}>
            <div className={deleteStyles.deleteConfirm}>
                <ModalBody classes={cls.textAlignCenter}>
                    {t('FilePreviewer.DeleteConfirm.text')}
                </ModalBody>
                <ModalFooter classes={cls.textAlignCenterFooter}>
                    <UiButton
                        btnColor="danger"
                        btnText={t('FilePreviewer.DeleteConfirm.deleteBtn')}
                        onClick={() => onDeleteFile(fileId)}
                    />
                    <UiButton
                        btnColor="secondary"
                        btnText={t('FilePreviewer.DeleteConfirm.secondaryBtn')}
                        onClick={onHideModal}
                    />
                </ModalFooter>
            </div>
        </div>
    );
};
